import {Calendar} from '@fullcalendar/core'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import nlLocale from '@fullcalendar/core/locales/nl';
import interactionPlugin from '@fullcalendar/interaction'

class FullCalendar {
	constructor(config) {
		this.config = Object.assign({
			scope: ''
		}, config);

		this.$scope = $(this.config.scope);
	}

	init() {
		return new Promise((resolve) => {
			let settings = Object.assign({
				plugins: [resourceTimelinePlugin, bootstrap5Plugin, interactionPlugin],
				editable: true,
				locale: nlLocale,
				customButtons: {
					filter: {
						icon: 'funnel-fill',
						click: () => {
							this.$scope.trigger('openFilterModal');
						}
					}
				},
				headerToolbar: {
					left: 'filter,today,prev,next',
					center: 'title',
					right: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth'
				},
				themeSystem: 'bootstrap5',
				initialView: 'resourceTimelineDay',
				schedulerLicenseKey: '0472581266-fcs-1715668338',
				events: route('api.v1.appointments.events'),
			});

			let calendar = new Calendar(this.$scope[0], settings);
			calendar.render();

			this.$scope.data('calendar', calendar);

			resolve(calendar);
		})

	}
}

export default FullCalendar;